import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import { Toaster } from "sonner";

const TITLES = {
  "/": { title: "Dashboard", subtitle: "Visão geral operacional" },
  "/agenda": { title: "Agenda", subtitle: "Calendário de eventos, serviços e consultas" },
  "/condominios": { title: "Condomínios", subtitle: "Gestão de edifícios e administradores" },
  "/empresas-condominio": { title: "Empresas de Condomínio", subtitle: "Administradoras e gestoras" },
  "/consultas": { title: "Consultas", subtitle: "Pedidos e contactos recebidos" },
  "/orcamentos": { title: "Orçamentos", subtitle: "Emissão e gestão de orçamentos" },
  "/registros": { title: "Registros", subtitle: "Serviços prestados aos condomínios" },
  "/relatorios": { title: "Relatórios", subtitle: "Análises exclusivas de administrador" },
  "/admin/users": { title: "Utilizadores", subtitle: "Gestão de acessos à plataforma" },
};

export default function Layout() {
  const location = useLocation();
  const meta = TITLES[location.pathname] || { title: "", subtitle: "" };

  return (
    <div className="min-h-screen flex bg-zinc-100">
      <Sidebar />
      <main className="flex-1 min-w-0 flex flex-col">
        <header
          className="h-20 flex-shrink-0 border-b border-zinc-200 bg-white/80 backdrop-blur-md sticky top-0 z-40 px-10 flex items-center justify-between"
          data-testid="page-header"
        >
          <div>
            <div className="text-[10px] uppercase tracking-[0.24em] text-neutral-400 font-chivo font-bold mb-1">
              CRM Condomínios
            </div>
            <h1 className="text-xl font-chivo font-black text-neutral-950 tracking-tight leading-none">
              {meta.title}
            </h1>
          </div>
          <div className="text-right">
            <div className="text-sm font-manrope text-neutral-600">{meta.subtitle}</div>
          </div>
        </header>
        <div className="flex-1 p-10 animate-in fade-in duration-300">
          <Outlet />
        </div>
      </main>
      <Toaster position="top-right" richColors />
    </div>
  );
}
